/* eslint-disable react/prop-types */
import styled, { css } from 'styled-components';
import { ComplaintSummaryReport } from './complaint-report-pane';
import { ViolationSummaryReport } from './violation-report-pane';

const ViolationsAndComplaints = styled.div`
  display: flex;
  flex-direction: row;
`;

const leftReportPaneStyle = css`
  flex: 1;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`;

const rightReportPaneStyle = css`
  flex: 1;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
`;

/**
 * Renders the violation report pane, and, optionally a similar report
 * pane to summarize complaints for the property details screen.
 * @param {object[]} props.listings Listings associated with the property being viewed
 * or a DATA_STATUS value if listings have not been loaded.
 * @param {object[]} props.complaints Complaints associated with the property being viewed
 * or a DATA_STATUS value if complaints have not been loaded.
 * @param {boolean} props.hideComplaints Set to true if the complaints summary box should be hidden
 * @returns {JSX.Element}
 * @constructor
 */
export function ViolationAndComplaintReport(props) {
  const { complaints, hideComplaints, listings } = props;

  return (
    <ViolationsAndComplaints>
      <ViolationSummaryReport
        css={!hideComplaints && leftReportPaneStyle}
        listings={listings}
      />

      {!hideComplaints && (
        <ComplaintSummaryReport
          css={rightReportPaneStyle}
          complaints={complaints}
        />
      )}
    </ViolationsAndComplaints>
  );
}
